module.exports = __webpack_public_path__ + "img/icon-38.5f1a095d.svg";